import React, { useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { MdSearch } from "react-icons/md";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import OrderRelated from "../OrderRelated/OrderRelated";
import GeneralRelated from "../OrderRelated/GeneralRelated";
import { useDispatch } from "react-redux";
import {
  getChatFlagGeneralSlice,
  getChatFlagOrderSlice,
} from "../../redux/ChatFlagSlice";

const AllMessages = ({ props, FlagFetchHandler, selectedChannel }) => {
  const [activeTab, setActiveTab] = useState("orderRelated");
  const [chatList, setChatList] = useState([]);

  const dispatch = useDispatch();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "orderRelated") {
      dispatch(getChatFlagOrderSlice(false));
      dispatch(getChatFlagGeneralSlice(false));
    } else {
      dispatch(getChatFlagOrderSlice(false));
      dispatch(getChatFlagGeneralSlice(false));
    }
    FlagFetchHandler(true);
  };
  return (
    <>
      <div className="msg-main mt-3">
        <div className={chatList === "" ? "msg-inner1" : "empty_msg-inner1"}>
          {/* <InputGroup className="search-bar">
            <InputGroup.Text>
              <MdSearch />
            </InputGroup.Text>
            <Form.Control placeholder="Search" />
          </InputGroup> */}
          {/* <Tabs
            defaultActiveKey="order-related"
            id="uncontrolled-tab-example"
            className="mb-3 order-related mt-3"
          >
            <Tab eventKey="order-related" title="Order Related">
              <OrderRelated />
            </Tab>
            <Tab eventKey="general" title="General">
              <GeneralRelated />
            </Tab>
          </Tabs> */}
          <div className="div_Chat_Heads">
            <div
              onClick={() => handleTabClick("orderRelated")}
              className={
                activeTab === "orderRelated" ? "active_Tab" : "non-active_Tab"
              }
            >
              Order Related
              {/*  */}
            </div>
            <div
              onClick={() => handleTabClick("general")}
              className={
                activeTab === "general" ? "active_Tab" : "non-active_Tab"
              }
            >
              General
            </div>
          </div>
          <div
            className={
              activeTab === "orderRelated" ? "display_Block" : "display_None"
            }
          >
            <OrderRelated
              SetChatList={setChatList}
              flagFetchHandler={FlagFetchHandler}
            />
          </div>
          <div
            className={
              activeTab === "general" ? "display_Block" : "display_None"
            }
          >
            <GeneralRelated flagFetchHandler={FlagFetchHandler} />
          </div>
        </div>
      </div>
    </>
  );
};

export default AllMessages;
